import MoreVertIcon from '@mui/icons-material/MoreVert';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Popover from '@mui/material/Popover';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { bindPopover, bindTrigger, usePopupState } from 'material-ui-popup-state/hooks';
import { forwardRef, ReactNode, useId } from 'react';

import { dashboardPageHeaderPrimaryActionsSx } from 'src/common/components/dashboard/dashboardPageHeaderStyles';

const dashboardCollapsibleActionsPopoverSx = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: 1.5,
  p: 2,
  minWidth: 220,
  maxWidth: '100vw',
  '& .MuiButton-root': {
    justifyContent: 'flex-start',
  },
} as const;

interface Props {
  children: ReactNode;
  ariaLabel: string;
}

/** Inline header actions on md+; overflow menu on narrow viewports. */
const DashboardCollapsibleHeaderActions = forwardRef<HTMLDivElement, Props>(
  function DashboardCollapsibleHeaderActions({ children, ariaLabel }, ref) {
    const popupId = useId();
    const popupState = usePopupState({ variant: 'popover', popupId });
    const theme = useTheme();
    const isWide = useMediaQuery(theme.breakpoints.up('md'));

    if (isWide) {
      return (
        <Box ref={ref} sx={dashboardPageHeaderPrimaryActionsSx}>
          {children}
        </Box>
      );
    }

    return (
      <Box ref={ref} sx={{ flexShrink: 0 }}>
        <IconButton {...bindTrigger(popupState)} aria-label={ariaLabel} size="small">
          <MoreVertIcon />
        </IconButton>
        <Popover
          {...bindPopover(popupState)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Box sx={dashboardCollapsibleActionsPopoverSx}>{children}</Box>
        </Popover>
      </Box>
    );
  },
);

export default DashboardCollapsibleHeaderActions;
